// Modules
import { useActiveCIPOrphanHook } from 'hooks/useActiveCIPOrphanHook'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

// Application
import { useAccountContext, useSignUp } from 'context'
import { useAccountService } from 'services/account'
import { ActivateStep, Contacts } from 'typings/account'
import { ContactList } from 'typings'
import { ROUTES_PATH } from 'constants/routesPath'

const LIVIA_LS_KEY = '@Livia'
const NAV_LS_KEY = '@NavAuth'
interface LocationState {
    originUrl: string
    data: {
        federalTaxId: string
        phoneContacts?: ContactList
        emailContacts?: ContactList
    }
}

export const useActivateHook = () => {
    const {
        state,
        operations: { setSubmitting, setContact, setPassword, resetAccountState, ...operations },
    } = useAccountContext()
    const { personalData: nameAndBirthDate } = useSignUp()
    const { viewerSearchPatient, setPersonalData: setPersonalDataPatient } = useActiveCIPOrphanHook()
    const { checkAccountService, createLogin, getContactsToReset, ...service } = useAccountService()
    const history = useHistory()
    const location = useLocation<LocationState>()

    useEffect(() => {
        const cpf = state?.cpf || location?.state?.data?.federalTaxId
        const contact = sessionStorage.getItem(`${NAV_LS_KEY}:Contact`)
        const emailContacts = state?.emailContacts || location?.state?.data?.emailContacts?.email
        const phoneContacts = state?.phoneContacts || location?.state?.data?.phoneContacts?.mobile
        const isRecoverPassword = !location?.state?.data?.federalTaxId
        operations.setAccount({
            cpf: cpf || undefined,
            emailContacts: emailContacts || undefined,
            phoneContacts: phoneContacts || undefined,
            contact: contact ? { ...JSON.parse(contact) } : {},
            isRecoverPassword,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.state?.data])

    const confirmToken = async (token: string) => {
        const { cpf: userName, password } = state
        const dataConfirmation = {
            userName,
            token,
            password,
        }
        const data = await service.confirmToken(dataConfirmation)

        if (!data || !data.confirmToken || !data.confirmToken.authentication) {
            return false
        }
        localStorage.setItem(
            LIVIA_LS_KEY,
            JSON.stringify({
                token: data.confirmToken.authentication.access_token,
                refreshToken: data.confirmToken.authentication.refresh_token,
            }),
        )

        return true
    }

    const setContacts = async (contacts: Contacts) => {
        operations.setCpf(contacts.cpf)
        operations.setPhoneContacts(contacts.emailContacts)
        operations.setEmailContacts(contacts.phoneContacts)
    }

    const nextStep = (): void => {
        const url = location?.state?.originUrl || ROUTES_PATH.SIGN_UP_REGISTRE_ACTIVATE_ACCOUNT

        if (state.step !== ActivateStep.validateToken) {
            history.push(url, { step: state.step, ...location?.state })
            operations.nextStep()
        }
    }

    const previousStep = (): void => {
        if (state.step !== ActivateStep.newPassword) {
            operations.previousStep()
        }
    }

    const moveToError = (path: string, historyState?: unknown): void => {
        history.push(path, historyState)
    }

    return {
        ...state,
        nameAndBirthDate,
        getContactsToReset,
        viewerSearchPatient,
        setPersonalDataPatient,
        nextStep,
        previousStep,
        moveToError,
        confirmToken,
        checkAccountService,
        createLogin,
        setSubmitting,
        setContact,
        setPassword,
        resetAccountState,
        setContacts,
    }
}
